import { DefaultCustomField } from 'src/constants/types';

/** Dot-separated segment for short URL metadata fields (e.g. `flyer_link.short`). */
const SHORT_URL_SUFFIX_SEGMENT = 'short';

export interface FormatCustomFieldOptions {
  includeClass?: boolean;
}

export const normalizeFieldType = (type?: string | null): string => (type || '').toLowerCase().replace(/[_-]/g, '');
export const isDateType = (type?: string | null): boolean => normalizeFieldType(type) === 'date';
export const isDateTimeType = (type?: string | null): boolean => normalizeFieldType(type) === 'datetime';
const isDateFieldType = (type?: string | null): boolean => isDateType(type) || isDateTimeType(type);

export function formatCustomFieldToHtml(
  text: string, 
  customFields: DefaultCustomField[], 
  options: FormatCustomFieldOptions = {}
): string {
  const { includeClass = false } = options;
  const formattedText = text.replaceAll('{{', '').replace('}}', '');
  
  // Check if there's a suffix (e.g., fieldName.date, fieldName.time, etc.)
  const parts = formattedText.split('.');
  const fieldName = parts.slice(0, -1).join('.'); // Get field name without suffix
  const suffix = parts.length > 1 ? parts[parts.length - 1] : null;
  
  // First try exact match; fall back to parent field only for date format suffixes.
  // `.short` fields are separate metadata entries — do not resolve to the parent URL field.
  let customField = customFields?.find(c => c.name === formattedText);
  if (!customField && suffix && suffix !== SHORT_URL_SUFFIX_SEGMENT) {
    customField = customFields?.find(c => c.name === fieldName);
  }
  
  if (!customField) {
    return '';
  }
  
  // Determine the display label based on suffix
  let displayLabel = customField.description;
  
  if (suffix && isDateFieldType(customField.type)) {
    switch (suffix) {
      case 'date':
        displayLabel = `${customField.description} (date only)`;
        break;
      case 'time':
        displayLabel = `${customField.description} (time only)`;
        break;
      case 'DMY':
        displayLabel = `${customField.description} (dd/mm/yyyy)`;
        break;
      case 'YMD':
        displayLabel = `${customField.description} (yyyy/mm/dd)`;
        break;
      case 'MDY':
        displayLabel = `${customField.description} (mm/dd/yyyy)`;
        break;
      default:
        displayLabel = customField.description;
    }
  }
  
  const classAttribute = includeClass ? ' class="mention"' : '';
  const html = `<span data-type="customFieldMention"${classAttribute} style="background-color:#ccc; border-radius: 7px; padding-left:3px; padding-right: 3px;" data-id="${formattedText}" data-label="${displayLabel}" contenteditable="false">${displayLabel}</span>`;

  return html;
} 
